// extracted by mini-css-extract-plugin
export default {"btnSecondary":"BtnSecondary_btnSecondary__nErNl","disabled":"BtnSecondary_disabled__6EPUB"};